module.exports = __webpack_public_path__ + "img/image14.1961f04d.svg";